import React, { Component } from 'react';
import moment from 'moment';

import CustomerOrderedProduct from './CustomerOrderedProduct';

export default class CustomerOrder extends Component {
	render() {
		const order = this.props.order;
		let products = [];
		let totalPrice = 0;
		if (order.productList && order.productList.length > 0) {
			products = order.productList.map((product, ind) => {
				totalPrice += parseInt(product.price, 10);
				return <CustomerOrderedProduct key={ product.id + "-ind-" + ind } product={ product } handleReorder={ this.props.handleReorder } handleReturn={ this.props.handleReturn } />;
			}
			);
		}
		const trackingUrl = order.userOrderDTO.trackingUrl;
		return (
			<div className="order">
				<div className="info">
					<div className="left-section">
						<div>{ 'Order number: ' + order.userOrderDTO.sourceOrderId }</div>
						<div>{ 'Ordered on: ' + moment(order.userOrderDTO.createdDate).format('MM/DD/YYYY') }</div>
						<div>Total: { "$" + totalPrice + ".00"}</div>
					</div>
					<div className="right-section">
					{ order.productList && <button style={{marginRight:"12px"}} onClick={ () => this.props.getSelectedOrderForRegimenCard(order.productList, order.userOrderDTO.id,order.userOrderDTO.sourceOrderId) }>Sync regimen card to order notes</button> }
						{ order.productList && <button onClick={ () => this.props.getSelectedOrderForRegimenCard(order.productList, order.userOrderDTO.id,null) }>Generate Regimen Card</button> }
						{ trackingUrl && <a href={ trackingUrl } target="_blank">Track package</a> }
					</div>
				</div>
				<div className="order-product-feed">
					{ products }
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/customersuccessportal/CustomerOrder.js